import { NewsListFilter } from "@pages/NewsList/NewsList.types";
import { CountryItem, IndustryItem } from "@type/common";

export const setURLfromFilters = (f: Omit<NewsListFilter, 'page'>) => {
  const url = new URL(window.location.href);
  url.searchParams.set('page', '0');
  url.searchParams.set('country', f.country || '');
  url.searchParams.set('industries', f.industries || '');
  url.searchParams.set('category', f.category || '');
  url.searchParams.set('startDate', f.startDate);
  url.searchParams.set('endDate', f.endDate);
  window.history.pushState({}, null, url);
};

export const getNameFromSubList = (id: string, list: (CountryItem | IndustryItem)[], subListName: string): string => {
  let returnName = '';
  list.forEach((item) => {
    item[subListName].forEach((subListItem) => {
      if (parseInt(subListItem.Id) === parseInt(id))
        returnName = subListItem.Name;
    });
  });
  return returnName;
};

export const getFiltersFromURL = (): Omit<NewsListFilter, 'page'> => {
  const url = new URL(window.location.href);

  return {
    country: url.searchParams.get('country') || '',
    industries: url.searchParams.get('industries') || '',
    category: url.searchParams.get('category') || '',
    startDate: url.searchParams.get('startDate') || '',
    endDate: url.searchParams.get('endDate') || '',
  };
};
